module.exports = __webpack_public_path__ + "static/media/Inter_18pt-Medium.8540f35b.ttf";